// The screens' code, one chunk each, loaded on demand. main.tsx's routes render them; lib/prefetch.ts
// asks for them early. Every route of the same file shares one load.
import { preloadable } from './lazy';
import { getLocale, loadCatalog } from '../i18n';

export const screens = {
  landing: preloadable(() => import('../pages/Landing')),
  auth: preloadable(() => import('../pages/Auth')),
  earn: preloadable(() => import('../pages/Earn')),
  cashout: preloadable(() => import('../pages/Cashout')),
  wallet: preloadable(() => import('../pages/Wallet')),
  rewards: preloadable(() => import('../pages/Rewards')),
  support: preloadable(() => import('../pages/Support')),
  account: preloadable(() => import('../pages/Account')),
  leaderboard: preloadable(() => import('../pages/Leaderboard')),
  // The Terms and Privacy Policy have a catalog of their own: big, and rarely read.
  legal: preloadable(() =>
    Promise.all([import('../pages/Legal'), loadCatalog(getLocale(), 'legal')]).then(([m]) => m),
  ),
  howItWorks: preloadable(() => import('../pages/info/HowItWorks')),
  waysToEarn: preloadable(() => import('../pages/info/WaysToEarn')),
  giftCards: preloadable(() => import('../pages/info/GiftCards')),
  faq: preloadable(() => import('../pages/info/Faq')),
};
